// @flow
import ServiceWorkerNotifierContainer from './ServiceWorkerNotifierContainer'

export default ServiceWorkerNotifierContainer
